.input {
    width: 130px;
    font-weight: 500;
}

.option[data-combobox-selected] {
    color: var(--mantine-color-ldGray-7);
    font-weight: 500;
    background-color: var(--mantine-color-ldGray-2);
}

.option[data-combobox-selected]:hover {
    background-color: var(--mantine-color-ldGray-3);
}

.option:hover {
    background-color: var(--mantine-color-ldGray-1);
}
